import * as React from 'react';

import { Select, SelectProps, MenuItem } from '@material-ui/core';
import CordovaContext from 'src/cordovaContext';
import { string } from 'prop-types';

interface IProps extends SelectProps{
  data?: Array<{value:string, element:JSX.Element}>;
  value:string;
}

interface IState {
  open: boolean;
}

class CustSelect extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      open:false,
    };
    
  }
  public render() {

    const data = this.props.data?this.props.data:[];
    
    return (
      <Select
        {...this.props}
        onClick = {() => this.setState({open:!this.state.open})}
        open={this.state.open}
        value={this.props.value}
      >
        {data.map((arrayItem, i) =>
          <MenuItem key={i} selected={this.props.value === arrayItem.value} value={arrayItem.value} >
            {arrayItem.element}
          </MenuItem>)}
      </Select>
    );
  }



}
CustSelect.contextType = CordovaContext;

export default (CustSelect);



// WEBPACK FOOTER //
// ./src/components/economy/CustSelect.tsx